











import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "powered-by-upmind": () => import("@/skeleton/poweredByUpmind.vue")
  }
})
export default class OrderSkeleton extends Vue {
  public mounted() {
    this.$emit("mounted");
  }
}
